module.exports = __webpack_public_path__ + "img/back.aa4fca85.jpg";